













































import { ICategory } from '@/types/category'
import Vue from 'vue'
import ActionBtn from './ActionBtn.vue'
import Description from './Description.vue'
import Wheel from './Wheel.vue'

declare global {
  interface Window { PayPal: any }
}
window.PayPal = window.PayPal || {}

export default Vue.extend({
  mounted() {
    setTimeout(() => {
      if (window.PayPal) {
        // @ts-expect-error
        window.PayPal.Donation.Button({
          env: 'production',
          hosted_button_id: 'HXKYQF3ALWKZ2',
          image: {
            alt: 'Donate with PayPal button',
            src: 'https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif',
            title: 'PayPal - The safer, easier way to pay online!',
          },
        }).render('#donate-button')
      }
    }, 1000)
  },
  components: {
        ActionBtn,
        Description,
        Wheel,
    },
    computed: {
        categories(): ICategory { return this.$store.state.categories },
        wheelKey(): number { return this.$store.state.wheelKey },
        descriptionKey(): number { return this.$store.state.descriptionKey },
        homeWheelKey(): number { return this.$store.state.homeWheelKey },
    },
    name: 'home',
})
